import {i18n} from '@/plugins/i18n'

export const walletStatus = {
    ACTIVE: 1,
    INACTIVE: 2,
};

export const walletStatusStr = {
    ACTIVE: i18n.t('label.active'),
    INACTIVE: i18n.t('label.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(walletStatus).forEach(item => {
            if (walletStatus[item] === status) {
                status_str = walletStatusStr[item];
            }
        });

        return status_str;
    }
};

export const walletStatusVariant = status => {
    if (status === walletStatus.ACTIVE) {
        return 'success';
    }

    if (status === walletStatus.INACTIVE) {
        return 'danger';
    }

    return 'warning';
};
